import { ROLES } from '@/constants/roles';

/**
 * La liste des enquetes qu'un role a le droit d'ouvrir.
 *
 * Le formulaire d'enquete est ouvert aux trois roles, mais les deux listes ne
 * le sont pas: `my-surveys` est reservee au Professionnel, `surveys` a
 * l'Admin et au SuperAdmin. Toute navigation vers "la liste" doit donc passer
 * par le role, sans quoi un Admin atterrit sur une page que son propre garde
 * de route lui refuse.
 *
 * @param {string} role - `userRole` du store d'authentification.
 * @returns {string} nom de route a passer a `$router.push`.
 */
export function surveyListRouteFor(role) {
  return role === ROLES.PROFESSIONAL ? 'my-surveys' : 'surveys';
}

export default { surveyListRouteFor };
